/**
 * ISO 3166-1 Country list for location tracking and marketing analytics
 */

export const COUNTRIES = [
  { code: 'GB', name: 'United Kingdom', region: 'Europe' },
  { code: 'US', name: 'United States', region: 'Americas' },
  { code: 'CA', name: 'Canada', region: 'Americas' },
  { code: 'AU', name: 'Australia', region: 'Oceania' },
  { code: 'NZ', name: 'New Zealand', region: 'Oceania' },
  { code: 'IE', name: 'Ireland', region: 'Europe' },
  { code: 'FR', name: 'France', region: 'Europe' },
  { code: 'DE', name: 'Germany', region: 'Europe' },
  { code: 'ES', name: 'Spain', region: 'Europe' },
  { code: 'IT', name: 'Italy', region: 'Europe' },
  { code: 'NL', name: 'Netherlands', region: 'Europe' },
  { code: 'BE', name: 'Belgium', region: 'Europe' },
  { code: 'CH', name: 'Switzerland', region: 'Europe' },
  { code: 'AT', name: 'Austria', region: 'Europe' },
  { code: 'DK', name: 'Denmark', region: 'Europe' },
  { code: 'SE', name: 'Sweden', region: 'Europe' },
  { code: 'NO', name: 'Norway', region: 'Europe' },
  { code: 'FI', name: 'Finland', region: 'Europe' },
  { code: 'PL', name: 'Poland', region: 'Europe' },
  { code: 'CZ', name: 'Czech Republic', region: 'Europe' },
  { code: 'PT', name: 'Portugal', region: 'Europe' },
  { code: 'GR', name: 'Greece', region: 'Europe' },
  { code: 'IN', name: 'India', region: 'Asia' },
  { code: 'SG', name: 'Singapore', region: 'Asia' },
  { code: 'JP', name: 'Japan', region: 'Asia' },
  { code: 'KR', name: 'South Korea', region: 'Asia' },
  { code: 'CN', name: 'China', region: 'Asia' },
  { code: 'AE', name: 'United Arab Emirates', region: 'Middle East' },
  { code: 'ZA', name: 'South Africa', region: 'Africa' },
  { code: 'BR', name: 'Brazil', region: 'Americas' },
  { code: 'MX', name: 'Mexico', region: 'Americas' },
  { code: 'AR', name: 'Argentina', region: 'Americas' },
  { code: 'OTHER', name: 'Other', region: 'Other' },
] as const;

export type CountryCode = typeof COUNTRIES[number]['code'];

/**
 * Track location change for marketing analytics
 */
export const trackLocationChange = async (
  userId: string,
  countryCode: string,
  previousLocation?: string
) => {
  const country = COUNTRIES.find(c => c.code === countryCode);
  
  return {
    event_name: 'location_updated',
    event_type: 'user_profile',
    user_id: userId,
    properties: {
      country_code: countryCode,
      country_name: country?.name,
      region: country?.region,
      previous_location: previousLocation,
      timestamp: new Date().toISOString(),
    }
  };
};
